import { Link } from "react-router-dom";
import { usePatientsBase } from "../../../utils/hubPaths";
import aa from "../AdminPortal/adminApp.module.css";

function telHref(phone) {
  if (!phone) return null;
  const digits = String(phone).replace(/\D/g, "");
  return digits ? `tel:+${digits.startsWith("7") ? digits : `7${digits.slice(-10)}`}` : null;
}

export default function ClientGuardianStrip({ guardians = [], primaryGuardian }) {
  const patientsBase = usePatientsBase();
  const list =
    guardians.length > 0
      ? guardians
      : primaryGuardian
        ? [
            {
              id: primaryGuardian.link_id,
              contact_name: primaryGuardian.full_name,
              contact_phone: primaryGuardian.phone,
              guardian_user_id: primaryGuardian.user_id,
              relation: primaryGuardian.relation,
              is_primary: true,
            },
          ]
        : [];

  if (!list.length) return null;

  const primary =
    list.find((g) => g.is_primary) ||
    list.find((g) => g.guardian_user_id) ||
    list[0];

  const name = primary.guardian?.full_name || primary.contact_name || "Родитель";
  const phone = primary.guardian?.phone || primary.contact_phone;
  const href = primary.guardian_user_id
    ? `${patientsBase}/${primary.guardian_user_id}`
    : telHref(phone);

  return (
    <section className={aa.clientGuardianStrip} aria-label="Родитель">
      <div className={aa.clientGuardianStripIcon} aria-hidden>
        👤
      </div>
      <div className={aa.clientGuardianStripBody}>
        <span className={aa.clientGuardianStripLabel}>
          {primary.relation ? `${primary.relation} · ` : ""}Родитель / плательщик
        </span>
        {href?.startsWith("tel:") ? (
          <a href={href} className={aa.clientGuardianStripName}>
            {name}
            {phone ? ` · ${phone}` : ""}
          </a>
        ) : (
          <Link to={href} className={aa.clientGuardianStripName}>
            {name}
            {phone ? ` · ${phone}` : ""}
          </Link>
        )}
        {list.length > 1 ? (
          <span className={aa.clientGuardianStripMeta}>
            +{list.length - 1} ещё в карточке
          </span>
        ) : null}
      </div>
      {href && !href.startsWith("tel:") ? (
        <Link to={href} className={aa.clientGuardianStripAction}>
          Карточка
        </Link>
      ) : phone ? (
        <a href={telHref(phone)} className={aa.clientGuardianStripAction}>
          Позвонить
        </a>
      ) : null}
    </section>
  );
}
